import { Skeleton } from "@/components/ui/atoms/skeleton";
import type { AccessReason } from "@/hooks/use-access-guard";
import { AuthPrompt } from "@/shared/auth-prompt";

interface AccessBlockedProps {
  reason: Exclude<AccessReason, null>;
  children?: React.ReactNode;
}

export function AccessBlocked({ reason, children }: AccessBlockedProps) {
  switch (reason.type) {
    case "loading":
      return (
        <div className="flex flex-1 items-center justify-center p-8">
          <div className="w-full max-w-md space-y-4">
            <Skeleton className="h-8 w-3/4" />
            <Skeleton className="h-64 w-full rounded-xl" />
          </div>
        </div>
      );
    case "unauthenticated":
      return <AuthPrompt />;
    case "rate-limited":
      return (
        <div className="flex flex-1 items-center justify-center p-8">
          <div className="flex flex-col items-center gap-2 text-center">
            <p className="text-lg font-semibold">Too many requests</p>
            <p className="text-sm text-muted-foreground">
              Please wait {reason.retryAfter ? `${reason.retryAfter} seconds` : "a moment"} before
              trying again.
            </p>
          </div>
        </div>
      );
    default:
      return <>{children}</>;
  }
}
